<template>
  <div class="avatar" :class="shape === 'circle' ? 'shape-circle' : ''">
    <img :src="avatarSrc">
  </div>
</template>

<script>
import systemAvatar from '@/assets/image/system.png'
export default {
  props: {
    src: String,
    type: {
      type: String,
      default: 'C2C'
    },
    shape: {
      type: String,
      default: 'circle'
    }
  },
  computed: {
    avatarSrc: function () {
      let src = this.src
      if (/^(https:|http:|\/\/)/.test(src)) {
        return src
      } else {
        return this.defaultSrc
      }
    },
    defaultSrc: function () {
      switch(this.type) {
        case 'C2C':
          // 个人头像
          return 'https://imgcache.qq.com/open/qcloud/video/act/webim-avatar/avatar-2.png'
        case 'GROUP':
          // 群默认头像
          return 'https://imgcache.qq.com/open/qcloud/video/act/webim-avatar/avatar-3.png'
        case this.TIM.TYPES.CONV_SYSTEM:
          return systemAvatar
        default:
          // 默认头像
          return 'https://imgcache.qq.com/open/qcloud/video/act/webim-avatar/avatar-1.png'
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
$bg = #4a5a6c;
$black = #000000;
$white = #ffffff;
// font-related
$base = #1c2438;
$regular = #495060;
// $first = #99a8b4
$first = #a5b5c1;
$secondary = #a5b5c1;
$font-light = #f7f7f8;
$font-dark = #76828c;
// border-related
$border-base = #e7e7e7;
$border-light = #e9eaec;
$border-highlight = #55d48b;
// theme-related
$dark-primary = #2b85e4;
$primary = #2d8cf0;
$light-primary = #5cadff;
// $light-primary = #55d48b
$success = #0ac160;
$warning = #fa9d3b;
$danger = #f35f5f;
// background-related
$light-background = #f2f7f7;
$background = #404953;
$dark-background = #363e47;
$deep-background = #303841;
$background = #404953;
$background-light = #f5f5f5;
$background-dark = #363e47;
$background-deep-dark = #303841;
$height = 80vh;
$width = 80vw;
.avatar 
  background-color $first
  text-align center
  width 100%
  height 100%
  overflow hidden
  img 
    width 100%
    height 100%
.shape-circle
  border-radius 50%
</style>



// WEBPACK FOOTER //
// src/components/imChat/avatar.vue